import { useTownConfig } from '../../stores';

function UsersPageSubmenu({ renderItems, translate }) {
  const { townConfig } = useTownConfig();

  return renderItems([
    { label: translate('members'), link: 'members' },
    { label: translate('moderation'), link: 'moderation', disabled: true },
    { label: translate('gdpr'), link: 'gdpr', disabled: true },
    {
      label: translate('townInvites'),
      link: 'townInvites',
      hide: townConfig?.cstmrType !== 'town',
    },
  ]);
}

export default UsersPageSubmenu;
